/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LearnMoreResponseAdminDto } from '../../models/learn-more-response-admin-dto';
import { ReorderLearnMoreDto } from '../../models/reorder-learn-more-dto';

export interface AdminLearnMoreControllerReorderLearnMoreV1$Params {
      body: ReorderLearnMoreDto
}

export function adminLearnMoreControllerReorderLearnMoreV1(http: HttpClient, rootUrl: string, params: AdminLearnMoreControllerReorderLearnMoreV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LearnMoreResponseAdminDto>>> {
  const rb = new RequestBuilder(rootUrl, adminLearnMoreControllerReorderLearnMoreV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LearnMoreResponseAdminDto>>;
    })
  );
}

adminLearnMoreControllerReorderLearnMoreV1.PATH = '/v1/admin/learn-more/reorder';
